import { MAX_DECIMAL } from "./DecimalConfiguration";

export const CONFIGURATIONS_FORM_VALIDATION_RULES = {
  authorizationCode: {
    isRequiredTrim: {
      value: true,
    },
    minLength: {
      value: 4,
    },
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/common/Configurations/ConfigurationsFormValidationRules.js